import { apiPost } from './client';

export interface SecuritiesEodIngestResult {
  rowsReceived: number;
  rowsUpserted: number;
}

// SysAdmin-only — gated server-side on `sysadminTools:Edit`. Triggers the TASE
// securities end-of-day rates ingest for the given date range (both optional;
// server defaults to today). Idempotent upsert — safe to widen the range to
// backfill a gap.
export function runSecuritiesEodIngest(
  fromDate?: string,
  toDate?: string,
): Promise<SecuritiesEodIngestResult> {
  const qs = new URLSearchParams();
  if (fromDate) qs.set('fromDate', fromDate);
  if (toDate) qs.set('toDate', toDate);
  const q = qs.toString();
  return apiPost<unknown, SecuritiesEodIngestResult>(
    `/api/securities-eod-rates/ingest${q ? `?${q}` : ''}`,
    {},
  );
}
